import React from 'react';
import '../../styles/tourist-nav.scss';

function ArrivalStepOutline({ steps }) {
	if (!steps || steps.length === 0) return null;

	return (
		<section className="arrival-outline">
			<h2 className="arrival-outline__title">Everything on this page — in order</h2>
			<p className="arrival-outline__intro">
				Scroll down for full detail on each step. Nothing here links away — visa, SIM, taxi, and Day 1 are all below.
			</p>
			<ol className="arrival-outline__list">
				{steps.map((step) => (
					<li key={step.id}>
						<a href={`#${step.id}`} className="arrival-outline__item">
							<span className="arrival-outline__num">{step.step}</span>
							<span className="arrival-outline__body">
								<strong>{step.question}</strong>
								<span>Read on this page ↓</span>
							</span>
						</a>
					</li>
				))}
			</ol>
		</section>
	);
}

export default ArrivalStepOutline;
